module.exports = __webpack_public_path__ + "static/bg-e52419719dd0c4c8b172136f0b625008.jpg";